import React from "react";
import { Card, CardHeader, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useStudentInfoHook from "../hook/StudentInfoHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";

const AdditionalReport = ({ schoolId, linkColor }) => {
  const { data, loading } = useStudentInfoHook(schoolId);

  const report_4_name = data.length > 0 ? data[0].report_4_name : "";
  const report_4_link = data.length > 0 ? data[0].report_4_link : "";
  const report_5_name = data.length > 0 ? data[0].report_5_name : "";
  const report_5_link = data.length > 0 ? data[0].report_5_link : "";
  const theme = useTheme();

  if (loading) {
    return <div>Loading...</div>;
  }
  const subject = "Additional Reports";

  return (
    <Card>
      <CardHeader
        title="Additional Reports"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {report_4_link && (
          <Typography component="div">
            <>
              <Link
                to={report_4_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: linkColor }}
              >
                View {report_4_name}
              </Link>
              <SchoolNotificationButton subject={subject} schoolId={schoolId} />
            </>
          </Typography>
        )}

        {report_5_link && (
          <Typography component="div">
            <>
              <Link
                to={report_5_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: linkColor }}
              >
                View {report_5_name}
              </Link>
              <SchoolNotificationButton subject={subject} schoolId={schoolId} />
            </>
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default AdditionalReport;
